import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const UserGroupIcon16 = (props: SvgProps) => (
  <Svg
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11 2a3.131 3.131 0 0 1 1.198 6.026c0 .178.454.233.68.238a3.132 3.132 0 0 1 3.133 3.133v.626s-.315.315-1.103.63l-.552.168m-4.023-7.488a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0ZM4.999 8.667A3.333 3.333 0 0 0 1.666 12v.667S2.999 14 6.999 14s5.334-1.333 5.334-1.333V12a3.333 3.333 0 0 0-3.334-3.333H5Z"
    />
  </Svg>
);
export default UserGroupIcon16;
